import * as React from "react";
import { Input as InputPrimitive } from "@base-ui/react/input";

import { cn } from "../../lib/utils";

type InputProps = Omit<React.ComponentProps<"input">, "size"> & {
  size?: "xs" | "sm" | "default" | "lg" | number | undefined;
};

function Input({ className, type, size = "default", ...props }: InputProps) {
  const resolvedSize = typeof size === "number" ? "default" : size;

  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      size={typeof size === "number" ? size : undefined}
      className={cn(
        "box-border flex w-full min-w-0 rounded-md border border-input bg-field px-2.5 py-0.5 text-nav leading-nav text-foreground outline-none placeholder:text-muted-foreground focus:border-ring focus-visible:border-ring disabled:cursor-not-allowed disabled:opacity-50",
        resolvedSize === "xs"
          ? "h-5 rounded-sm px-1.5 text-caption leading-caption"
          : resolvedSize === "sm"
            ? "h-6 px-2 text-xs leading-none"
            : resolvedSize === "lg"
              ? "h-8 py-1 text-sm leading-sm"
              : "h-7",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
